import { render } from "./BetBox.vue?vue&type=template&id=1e9a955a&scoped=true&ts=true"
import script from "./BetBox.vue?vue&type=script&lang=ts"
export * from "./BetBox.vue?vue&type=script&lang=ts"

import "./BetBox.vue?vue&type=style&index=0&id=1e9a955a&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\new2h5\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9a955a"]])

export default __exports__